(function () {
  function norm(x) {
    return (x === null || x === undefined ? '' : String(x)).trim().toLowerCase();
  }

  function initProductPage(root) {
    if (root.dataset.mpInit) return;
    root.dataset.mpInit = 'true';

    /* 0-based option index, -1 means the product has no such option */
    var colorIndex = parseInt(root.dataset.colorIndex, 10);
    var sizeIndex = parseInt(root.dataset.sizeIndex, 10);
    if (isNaN(colorIndex)) colorIndex = -1;
    if (isNaN(sizeIndex)) sizeIndex = -1;

    var variantsScript = root.querySelector('script[id^="ProductVariants-"]');
    var variants = [];
    try {
      variants = variantsScript ? JSON.parse(variantsScript.textContent) : [];
    } catch (e) {
      variants = [];
    }

    /* ===== Gallery ===== */
    var track = root.querySelector('.mp-gallery__track');
    var slides = Array.prototype.slice.call(root.querySelectorAll('.mp-gallery__slide'));
    var dots = root.querySelectorAll('.mp-gallery__dot');
    var visibleSlides = slides.slice();
    var prevBtn = root.querySelector('.mp-gallery__arrow--prev');
    var nextBtn = root.querySelector('.mp-gallery__arrow--next');
    var current = 0;

    /* Updates dots + arrows for the slides currently visible */
    function syncDots() {
      var total = visibleSlides.length;

      dots.forEach(function (dot, i) {
        dot.style.display = total > 1 && i < total ? '' : 'none';
        dot.classList.toggle('is-active', i === current);
      });

      /* No arrows for a single image; no left arrow on the first, no right arrow on the last */
      if (prevBtn) prevBtn.style.display = total > 1 && current > 0 ? '' : 'none';
      if (nextBtn) nextBtn.style.display = total > 1 && current < total - 1 ? '' : 'none';
    }

    function scrollToSlide(index) {
      if (!visibleSlides.length) return;
      current = Math.max(0, Math.min(index, visibleSlides.length - 1));
      var target = visibleSlides[current];
      if (target && track) {
        track.scrollTo({ left: target.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      }
      syncDots();
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { scrollToSlide(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollToSlide(current + 1); });

    if (track) {
      track.addEventListener('scroll', function () {
        var closest = 0;
        var closestDist = Infinity;
        visibleSlides.forEach(function (slide, i) {
          var dist = Math.abs(slide.offsetLeft - track.scrollLeft - track.offsetLeft);
          if (dist < closestDist) {
            closestDist = dist;
            closest = i;
          }
        });
        current = closest;
        syncDots();
      });
    }

    /* ===== Elements ===== */
    var swatches = root.querySelectorAll('.mp-swatch');
    var selectedColorLabel = root.querySelector('[data-role="selected-color"]');
    var sizeBtns = root.querySelectorAll('.mp-size');
    var priceEl = root.querySelector('[data-role="price"]');
    var compareEl = root.querySelector('[data-role="compare-price"]');
    var stockEl = root.querySelector('[data-role="stock"]');
    var variantIdInput = root.querySelector('[data-role="variant-id"]');
    var cartSubmit = root.querySelector('[data-role="cart-submit"]');
    var buyNowBtn = root.querySelector('[data-role="buy-now"]');

    /* ===== Money: uses the store's own currency format (e.g. "Rs. {{amount}}") ===== */
    var moneyFormatString = root.dataset.moneyFormat || 'Rs. {{amount}}';

    function addThousands(str, sep) {
      return str.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
    }

    function moneyFormat(cents) {
      var value = (cents / 100).toFixed(2);
      var parts = value.split('.');
      var whole = parts[0];
      var decimals = parts[1];

      return moneyFormatString.replace(/\{\{\s*(\w+)\s*\}\}/, function (match, type) {
        switch (type) {
          case 'amount':
            return addThousands(whole, ',') + '.' + decimals;
          case 'amount_no_decimals':
            return addThousands(whole, ',');
          case 'amount_with_comma_separator':
            return addThousands(whole, '.') + ',' + decimals;
          case 'amount_no_decimals_with_comma_separator':
            return addThousands(whole, '.');
          case 'amount_with_apostrophe_separator':
            return addThousands(whole, "'") + '.' + decimals;
          case 'amount_no_decimals_with_space_separator':
            return addThousands(whole, ' ');
          case 'amount_with_space_separator':
            return addThousands(whole, ' ') + ',' + decimals;
          default:
            return addThousands(whole, ',') + '.' + decimals;
        }
      });
    }

    /* ===== Variant matching ===== */
    function variantMatches(v, colorValue, sizeValue) {
      var opts = v.options || [];
      if (colorIndex >= 0 && colorValue !== null && norm(opts[colorIndex]) !== norm(colorValue)) return false;
      if (sizeIndex >= 0 && sizeValue !== null && norm(opts[sizeIndex]) !== norm(sizeValue)) return false;
      return true;
    }

    /* Prefer an in-stock variant if several share the same color + size (e.g. a 3rd option exists) */
    function findVariant(colorValue, sizeValue) {
      var matches = variants.filter(function (v) { return variantMatches(v, colorValue, sizeValue); });
      if (!matches.length) return null;
      var inStock = matches.filter(function (v) { return v.available; });
      return inStock.length ? inStock[0] : matches[0];
    }

    function getActiveColor() {
      var el = root.querySelector('.mp-swatch.is-active');
      return el ? el.dataset.value : null;
    }

    function getActiveSize() {
      var el = root.querySelector('.mp-size.is-active');
      return el ? el.dataset.value : null;
    }

    /* Cross out / disable sizes that don't exist for the selected color */
    function updateSizeAvailability(colorValue) {
      if (!sizeBtns.length) return;

      sizeBtns.forEach(function (btn) {
        var exists = variants.some(function (v) {
          return variantMatches(v, colorValue, btn.dataset.value);
        });

        if (!exists) {
          btn.disabled = true;
          btn.classList.add('is-unavailable');
          btn.classList.remove('is-active');
        } else {
          btn.disabled = false;
          btn.classList.remove('is-unavailable');
        }
      });

      var activeSize = root.querySelector('.mp-size.is-active');
      if (!activeSize || activeSize.disabled) {
        sizeBtns.forEach(function (btn) { btn.classList.remove('is-active'); });

        /* Prefer the first size that is actually in stock for this color */
        var firstInStock = null;
        var firstExisting = null;
        sizeBtns.forEach(function (btn) {
          if (btn.disabled) return;
          if (!firstExisting) firstExisting = btn;
          var inStock = variants.some(function (v) {
            return v.available && variantMatches(v, colorValue, btn.dataset.value);
          });
          if (inStock && !firstInStock) firstInStock = btn;
        });

        var pick = firstInStock || firstExisting;
        if (pick) pick.classList.add('is-active');
      }
    }

    function updateVariant() {
      var match = findVariant(getActiveColor(), getActiveSize());

      if (!match) {
        if (stockEl) stockEl.textContent = 'This combination is unavailable';
        if (cartSubmit) {
          cartSubmit.disabled = true;
          cartSubmit.textContent = 'Unavailable';
        }
        if (buyNowBtn) buyNowBtn.disabled = true;
        if (variantIdInput) variantIdInput.value = '';
        return;
      }

      if (priceEl) priceEl.textContent = moneyFormat(match.price);

      if (compareEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          compareEl.textContent = moneyFormat(match.compare_at_price);
          compareEl.hidden = false;
        } else {
          compareEl.textContent = '';
          compareEl.hidden = true;
        }
      }
      if (variantIdInput) variantIdInput.value = match.id;

      /* Update the URL so the selected variant is shareable / refresh-safe */
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) { /* ignore */ }

      if (match.available) {
        if (stockEl) {
          var threshold = parseInt(root.dataset.lowStockThreshold, 10);
          if (isNaN(threshold)) threshold = 5;
          var qty = parseInt(match.inventory_quantity, 10);
          if (match.inventory_management && !isNaN(qty) && qty > 0 && qty <= threshold) {
            stockEl.textContent = 'Hurry, only ' + qty + ' left! ✓';
          } else {
            stockEl.textContent = 'In stock ✓';
          }
        }
        if (cartSubmit) {
          cartSubmit.disabled = false;
          cartSubmit.textContent = 'Add to Cart';
        }
        if (buyNowBtn) buyNowBtn.disabled = false;
      } else {
        if (stockEl) stockEl.textContent = 'Sold out';
        if (cartSubmit) {
          cartSubmit.disabled = true;
          cartSubmit.textContent = 'Sold Out';
        }
        if (buyNowBtn) buyNowBtn.disabled = true;
      }
    }

    function applySwatch(swatch) {
      swatches.forEach(function (s) { s.classList.remove('is-active'); });
      swatch.classList.add('is-active');
      if (selectedColorLabel) selectedColorLabel.textContent = swatch.dataset.value;

      /* Show only the slides whose image alt text contains this color's name.
         If no image mentions the color, show all images (nothing is hidden or repeated). */
      var colorName = norm(swatch.dataset.value);
      var matched = slides.filter(function (slide) {
        var img = slide.querySelector('img');
        return img && norm(img.alt).indexOf(colorName) !== -1;
      });
      visibleSlides = matched.length ? matched : slides.slice();

      slides.forEach(function (slide) {
        slide.style.display = visibleSlides.indexOf(slide) !== -1 ? '' : 'none';
      });

      if (track) track.scrollLeft = 0;
      scrollToSlide(0);
      updateSizeAvailability(swatch.dataset.value);
      updateVariant();
    }

    swatches.forEach(function (swatch) {
      swatch.addEventListener('click', function () { applySwatch(swatch); });
    });

    sizeBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        sizeBtns.forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        updateVariant();
      });
    });

    /* Default view: first color's images + correct size availability */
    syncDots();

    if (swatches.length) {
      applySwatch(swatches[0]);
    } else {
      updateSizeAvailability(null);
      updateVariant();
    }

    /* ===== Quantity controls ===== */
    var qtyInput = root.querySelector('[data-role="qty-input"]');
    var qtyMinus = root.querySelector('[data-role="qty-minus"]');
    var qtyPlus = root.querySelector('[data-role="qty-plus"]');

    if (qtyMinus && qtyInput) {
      qtyMinus.addEventListener('click', function () {
        var val = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = Math.max(1, val - 1);
      });
    }
    if (qtyPlus && qtyInput) {
      qtyPlus.addEventListener('click', function () {
        var val = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = val + 1;
      });
    }

    /* ===== Buy it Now — adds to cart then jumps straight to checkout ===== */
    if (buyNowBtn) {
      buyNowBtn.addEventListener('click', function () {
        if (buyNowBtn.disabled) return;
        var variantId = variantIdInput ? variantIdInput.value : null;
        var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
        if (!variantId) return;

        buyNowBtn.disabled = true;
        var originalText = buyNowBtn.textContent;
        buyNowBtn.textContent = 'Redirecting...';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: qty })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('Add to cart failed');
            return res.json();
          })
          .then(function () {
            window.location.href = '/checkout';
          })
          .catch(function (err) {
            console.error('Buy it Now failed', err);
            buyNowBtn.disabled = false;
            buyNowBtn.textContent = originalText;
          });
      });
    }

    /* ===== WhatsApp link ===== */
    var whatsappLink = root.querySelector('[data-role="whatsapp-link"]');
    if (whatsappLink) {
      var number = (whatsappLink.dataset.number || '').replace(/[^0-9]/g, '');
      var message = whatsappLink.dataset.message || '';
      whatsappLink.href = 'https://wa.me/' + number + '?text=' + encodeURIComponent(message);
    }

    /* ===== Sale countdown ===== */
    var timer = root.querySelector('.mp-sale-timer');
    if (timer) {
      var endTime = new Date(timer.dataset.endTime).getTime();
      var countdownEl = timer.querySelector('[data-role="countdown"]');
      var timerId = null;

      function tick() {
        var now = new Date().getTime();
        var diff = endTime - now;
        if (isNaN(diff) || diff <= 0) {
          timer.style.display = 'none';
          if (timerId) clearInterval(timerId);
          return;
        }
        var d = Math.floor(diff / (1000 * 60 * 60 * 24));
        var h = Math.floor((diff / (1000 * 60 * 60)) % 24);
        var m = Math.floor((diff / (1000 * 60)) % 60);
        var s = Math.floor((diff / 1000) % 60);
        if (countdownEl) {
          countdownEl.textContent = d + 'd : ' + h + 'h : ' + m + 'm : ' + s + 's';
        }
      }

      tick();
      timerId = setInterval(tick, 1000);
    }

    /* ===== Sliding panels (Shipping / Information / Benefits / Video / Reviews) ===== */
    var panelOpeners = root.querySelectorAll('[data-panel-open]');
    panelOpeners.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var name = btn.dataset.panelOpen;
        var panel = root.querySelector('.mp-panel[data-panel-name="' + name + '"]');
        if (panel) {
          panel.classList.add('is-open');
          panel.setAttribute('aria-hidden', 'false');
          document.body.style.overflow = 'hidden';
        }
      });
    });

    root.querySelectorAll('[data-role="panel-close"]').forEach(function (el) {
      el.addEventListener('click', function () {
        var panel = el.closest('.mp-panel');
        if (panel) {
          panel.classList.remove('is-open');
          panel.setAttribute('aria-hidden', 'true');
          document.body.style.overflow = '';
        }
      });
    });
  }

  function initAll(scope) {
    var root = scope || document;
    root.querySelectorAll('product-page').forEach(initProductPage);
  }

  document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();